<template>
  <div class="reportQuerySummaryDetail">
    <van-form label-width="120px">
      <div class="title">{{ $t.meta.basicTitle }}</div>
      <van-field
        v-model="form.PWB_Number"
        :label="$t.reportQuerySummary.mainWbNumber"
        readonly
      />
      <van-field
        v-model="form.WB_Number"
        :label="$t.reportQuerySummary.sideWbNumber"
        readonly
      />
      <van-field
        v-model="form.WarehouseWorkNumber"
        :label="$t.reportQuerySummary.warehouseWorkNumber"
        readonly
      />
      <van-field
        v-model="form.WorkOrderNumber"
        :label="$t.reportQuerySummary.jobNumber"
        readonly
      />
      <van-field v-model="form.Sales" :label="$t.reportQuerySummary.recommend" readonly />
      <div v-if="form.menuState == 2">
        <van-field
          v-model="form.CompanyNameSn"
          :label="$t.reportQuerySummary.payerName2"
          readonly
        />
        <van-field
          v-model="form.FinancialAccountNo"
          :label="$t.reportQuerySummary.financialAccountNo"
          readonly
        />
        <van-field
          v-model="isPayrollRequest"
          :label="$t.reportQuerySummary.payrollRequest"
          :label-class="form.IsPayrollRequest == 1 ? 'number-label' : ''"
          readonly
        >
          <template #button>
            <van-button
              size="small"
              type="info"
              @click="toPayrollRecords(form.CostId)"
              v-if="form.IsPayrollRequest == 1"
              >{{ $t.meta.detail }}</van-button
            >
          </template>
        </van-field>
      </div>
      <div v-else>
        <van-field
          v-model="form.CompanyNameSn"
          :label="$t.reportQuerySummary.payerName1"
          readonly
        />
        <van-field
          v-model="form.InvoiceNo"
          :label="$t.reportQuerySummary.invoiceNo"
          readonly
        />
      </div>

      <van-field
        v-model="form.InvoiceDate"
        :label="$t.reportQuerySummary.createDate"
        readonly
      />
      <div class="title">{{ $t.reportQuerySummary.tradeTitle }}</div>
      <van-field
        v-model="form.POL"
        :label="$t.reportQuerySummary.deliveryPort"
        readonly
      />
      <van-field
        v-model="form.POD"
        :label="$t.reportQuerySummary.destinationPort"
        readonly
      />
      <van-field v-model="form.ATD" :label="$t.reportQuerySummary.atd" readonly />
      <div class="title">{{ $t.reportQuerySummary.amountTitle }}</div>

      <div v-if="form.menuState == 2">
        <div
          class="subTotal"
          v-if="form.BalanceAmountList && form.BalanceAmountList.length > 0"
        >
          <div class="subTotal-label">{{ $t.reportQuerySummary.total }}</div>
          <div
            class="subTotal-item"
            v-for="(item, index) in form.BalanceAmountList"
            :key="index"
          >
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.BalanceAmount }}</div>
          </div>
        </div>
      </div>
      <div v-else>
        <van-field
          v-model="form.InvoiceAmount"
          :label="$t.reportQuerySummary.total + '(' + settlementCurrency + ')'"
          readonly
        />
        <van-field
          v-model="form.OutStandingDays"
          :label="$t.reportQuerySummary.outStandingDays"
          readonly
        />
        <van-field
          v-model="form.CreditAmountBalance"
          :label="$t.reportQuerySummary.creditBalance"
          readonly
        />
        <div
          class="subTotal"
          v-if="form.BalanceAmountList && form.BalanceAmountList.length > 0"
        >
          <div class="subTotal-label">{{ $t.reportQuerySummary.balance }}</div>
          <div
            class="subTotal-item"
            v-for="(item, index) in form.BalanceAmountList"
            :key="index"
          >
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.BalanceAmount }}</div>
          </div>
        </div>

        <van-field
          v-model="form.ReceivableBalance"
          :label="$t.reportQuerySummary.totalBalance + '(' + settlementCurrency + ')'"
          readonly
        />
      </div>

      <div class="subTotal" v-if="rateList && rateList.length > 0">
        <div class="subTotal-label">{{ $t.reportQuerySummary.rate }}</div>
        <div class="subTotal-item" v-for="(item, index) in rateList" :key="index">
          <div class="item1">{{ item.CurrencySn }}</div>
          <div class="item2">{{ item.Rate }}</div>
        </div>
      </div>

      <div class="multi-table" v-if="invoiceList.length > 0">
        <van-field name="stepper" :label="$t.reportQuerySummary.taxInvoice">
          <template #input>
            <van-stepper :min="0" :value="invoiceList.length" :disabled="true" />
          </template>
        </van-field>
        <div v-for="(item, index) in invoiceList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">No.{{ index + 1 }}</div>
          </div>
          <van-field
            v-model="item.TaxInvoiceNumber"
            :label="$t.reportQuerySummary.invoiceNumber"
            readonly
          />
          <van-field :label="$t.reportQuerySummary.invoiceFile">
            <template #input>
              <van-image
                width="80"
                height="80"
                fit="contain"
                @click="imagePreview(imgUrlFilter(item.InvoiceFileAddress))"
                :src="imgUrlFilter(item.InvoiceFileAddress)"
              />
            </template>
          </van-field>
        </div>
      </div>

      <div class="multi-table" v-if="taxInvoice">
        <van-field :label="$t.reportQuerySummary.taxInvoice">
          <template #input>
            <van-image
              width="80"
              height="80"
              fit="contain"
              @click="imagePreview(imgUrlFilter(taxInvoice))"
              :src="imgUrlFilter(taxInvoice)"
            />
          </template>
        </van-field>
      </div>
    </van-form>

    <van-action-sheet v-model="sheetShow" :actions="sheetActions" @select="sheetSelect" />

    <div class="tool-bar">
      <van-button type="info" block @click="handleSheetShow" v-if="form.menuState == 2">{{
        $t.meta.menu
      }}</van-button>
      <van-button type="info" block @click="toBillsReceivable" v-else>{{
        $t.reportQuerySummary.billDetail
      }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Uploader,
  Picker,
  Popup,
  Stepper,
  ActionSheet,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Uploader)
  .use(Picker)
  .use(Popup)
  .use(Stepper)
  .use(ActionSheet);

export default {
  name: "reportQuerySummaryDetail",
  data() {
    return {
      SettlementCurrency: "",
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      form: {},
      isPayrollRequest: "",
      invoiceList: [],
      taxInvoice: "",
      rateList: [],
      //操作菜单
      sheetShow: false,
      sheetActions: [],
    };
  },
  created() {
    var data = JSON.parse(localStorage.getItem("reportQuerySummaryDetail"));
    this.form = data;
    this.settlementCurrency = data.SettlementCurrency;
    this.rateList = data.RateList;
    this.firstLoad();
  },
  methods: {
    sheetSelect(e) {
      if (e.className == "1") {
        this.toSupplierCostEntry();
      }
      if (e.className == "2") {
        this.toPayrollDetails();
      }
    },
    handleSheetShow() {
      var actions = [
        { name: this.$t.reportQuerySummary.viewCost, className: "1" },
        { name: this.$t.reportQuerySummary.bill, className: "2" },
      ];
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    firstLoad() {
      if (this.form.InvCount) {
        this.getInvoiceFileListByInvoiceNo();
      }
      if (this.form.TaxInvoice) {
        this.taxInvoice = this.form.TaxInvoice;
      }
      if (this.form.IsPayrollRequest == 1) {
        this.isPayrollRequest = this.$t.meta.yes;
      } else {
        this.isPayrollRequest = this.$t.meta.no;
      }
    },
    toPayrollRecords(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "payrollRecords",
        name: "payrollRecords",
        query: [
          {
            name: "CostId",
            value: id,
          },
        ],
      });
    },
    toBillsReceivable() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "billsReceivable",
        name: "billsReceivable",
        query: [
          {
            name: "InvoiceNo",
            value: this.form.InvoiceNo,
          },
        ],
      });
    },
    toSupplierCostEntry() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "supplierCostEntry",
        name: "supplierCostEntry",
        query: [
          {
            name: "FinancialAccountNo",
            value: this.form.FinancialAccountNo,
          },
        ],
      });
    },
    toPayrollDetails() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "payrollDetails",
        name: "payrollDetails",
        query: [
          {
            name: "FinancialAccountNoList",
            value: [this.form.FinancialAccountNo],
          },
          {
            name: "Type",
            value: "new",
          },
        ],
      });
    },
    getInvoiceFileListByInvoiceNo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          InvoiceNo: this.form.InvoiceNo,
        };
        this.$api.financialManagement
          .getInvoiceFileListByInvoiceNo(param)
          .then((res) => {
            this.invoiceList = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.reportQuerySummaryDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .subTotal {
    padding: 15px;
    font-size: 14px;
    color: #646566;
    .subTotal-label {
      margin-bottom: 15px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      .item1 {
        padding: 10px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 10px;
        background: #e8f4ff;
      }
    }
  }
  .multi-table {
    margin-top: 20px;
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 100%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
